import { recordResponseSerializer } from "@api/utils";

const FAQSerializers = {
  responseSerializer: function (hit) {
    return recordResponseSerializer(hit);
  },
};

export const faqsSerializer = {
  fromJSON: FAQSerializers.responseSerializer,
};
